import {connect} from 'react-redux';
import {calculateCollegeGpa} from 'shared/utils';
import {openModal} from 'shared/actions/modal';
import TransferAboutMe from 'src/views/transfer/AboutMe/AboutMe';
import {getFollowedCollegesNextTransferTerms} from 'portfolio/components/colleges-not-offering-transfer-term-modal/actions';
import {COLLEGES_NOT_OFFERING_TRANSFER_TERM_MODAL} from 'portfolio/components/colleges-not-offering-transfer-term-modal/colleges-not-offering-transfer-term-modal';

const mapStateToProps = (state) => {
  const {student} = state;
  const gpaInfo = calculateCollegeGpa(state.collegeCourses);

  const gpa = gpaInfo?.gpa || null;
  const hasCoursesOverTenYears = gpaInfo ? gpaInfo.hasCoursesOverTenYears : false;

  return {
    student: {
      ...student,
      gpa,
      hasCoursesOverTenYears,
    },
  };
};

const mapDispatchToProps = (dispatch) => ({
  openCollegesNotOfferingTransferTermModal: (term) => {
    dispatch(getFollowedCollegesNextTransferTerms(term));
    dispatch(openModal(COLLEGES_NOT_OFFERING_TRANSFER_TERM_MODAL));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TransferAboutMe);
